import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import styles from './strike-through-tag.module.css'

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    text: PropTypes.string,
    unavailable: PropTypes.bool
}

const defaultProps = {
    unavailable: false
}

function StrikeThroughTag({ children, className, text, unavailable }) {
    return (
        <div className={cx(styles['strike-through-tag'], { [styles['unavailable']]: unavailable }, className)}>
            {children || text}
            {unavailable && (
                <svg className={styles['diagonal']}>
                    <line className={styles['line']} x1={0} y1="100%" x2="100%" y2={0} />
                </svg>
            )}
        </div>
    )
}

StrikeThroughTag.propTypes = propTypes
StrikeThroughTag.defaultProps = defaultProps

export { StrikeThroughTag }
